export default () => ({

    menu_breakpoint_width: 1024,

    is_menu_open: false,
    is_on_dark: false,
    is_premiere: false,
    is_transparent: false,
    is_transparent_on_dark: false,
    is_collapsed: false,
    has_active_item: false,
    has_hover_cooldown: false,
    scrollbar_width: 0,
    base_url: '/',
    lang: 'ru',

    // Мобильный экран
    is_mobile: false,

    // Режим поиска
    is_search_mode: false,

    // Способ открытия плашки поиска: '' | 'button' | 'keypress'
    search_opened_by: '',

    // Поисковый запрос
    search_query: '',

    // Минимальное число символов для запроса подсказок
    search_query_min_length: 2,

    // Подсказки для поля поиска (результат)
    search_suggestions: [],

    // Индекс выделенного пункта подсказок при навигации с клавиатуры
    // (0 — оригинальный запрос, если он есть; -1 — выделения нет)
    search_selected_index: -1,

    // Подсказки при поиске по умолчанию
    search_suggestions_default: [],

    // Подсказки при поиске для текущего запроса
    search_suggestions_query: [],

    // Навигационные подсказки-переходы для текущего запроса (объекты {text, url})
    search_suggestions_nav: [],

    // Кэш навигационных подсказок по запросу в рамках визита
    search_suggestions_nav_stored: [],

    // Максимальное количество навигационных подсказок (показываются сверху списка)
    search_suggestions_nav_max: 2,

    // Сохраненные подсказки по запросам в рамках визита
    search_suggestions_stored: [],

    // Исправление-синоним по запросу (ключ — запрос, значение — правильное слово).
    // Нужно, чтобы фильтр подсказок не выкинул исправление, не содержащее запрос.
    search_suggestions_correction: [],

    // Максимальное количество подсказок под полем поиска
    search_suggestions_max: 5,

    // HTML-код карточки события, найденного при поиске
    search_suggested_event_html: '',

    nav_height: 80,

    visit_menu_item: '',
    active_menu_item: '',
    mobile_menu_item: '',
    active_menu_item_title: '',

    // Загруженный элемент меню (для отрисовки анимации)
    selected_menu_item: '',

    // Таймаут для активации элемента при удержании курсора мыши
    hover_timeout: null,
    // Время удержания курсора для активации элемента меню
    hover_timeout_duration: 100,

    // Свойства плавающего индикатора
    active_menu_item_left: 0,
    active_menu_item_width: 0,
    active_menu_item_opacity: 0,

    scroll_top: 0,
    last_scroll_top: 0,
    scroll_vector: 0,
    scroll_direction: null,

    transparent_trigger: null,
    transparent_trigger_start: 0,
    transparent_trigger_end: 0,

    /**
     * Директивы для шапки сайта
     */
    header: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'is-menu-open': this.isHeaderMenuOpen(),
                'is-collapsed': this.isCollapsed(),
                'is-transparent': this.is_transparent,
                'dark':
                    (
                        this.is_on_dark
                        ||
                        (
                            this.is_transparent
                            &&
                            this.is_transparent_on_dark
                        )
                    )
                    &&
                    !this.isHeaderMenuOpen()
                    &&
                    !this.is_search_mode
            }
        },

        /**
         * Действие при нажатии клавиши ESC
         */
        ['x-on:keydown.window.esc']() {
            // noinspection JSUnresolvedReference
            this.closeHeaderMenu();
        },

        /**
         * Ловушка фокуса при открытом меню сайта
         */
        ['x-trap.noautofocus.inert']() {
            // noinspection JSUnresolvedReference
            return this.isHeaderMenuOpen()
        },

        ['x-resize']() {
            this.is_mobile = this.isMobile();
        }
    },

    /**
     * Директивы для фоновой плашки, отображаемой при открытом меню сайта
     */
    backdrop: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'bg-white lg:bg-bunker-950/90': this.isHeaderMenuOpen(),
                'bg-bunker-950/20 dark:bg-white/20': this.is_search_mode
            }
        },

        /**
         * Условие отображение фоновой плашки
         */
        ['x-show']() {
            // noinspection JSUnresolvedReference
            return this.isHeaderMenuOpen() || this.is_search_mode
        },

        /**
         * Нажатие на фоновую плашку закрывает меню сайта
         */
        ['x-on:click.stop']() {
            // noinspection JSUnresolvedReference
            if (this.isHeaderMenuOpen()) {
                // noinspection JSUnresolvedReference
                this.closeHeaderMenu()
            }

            // noinspection JSUnresolvedReference
            if (this.is_search_mode) {
                this.is_search_mode = false;
            }
        },
    },

    search_backdrop: {
        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'hidden': !this.is_search_mode
            }
        },

        /**
         * Динамическая установка стилей
         */
        ['x-bind:style']() {
            // noinspection JSUnresolvedReference
            return {
                'height': this.nav_height + 'px'
            }
        },
    },

    /**
     * Навигационная панель
     */
    nav: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {

                'is-collapsed -translate-y-full print:translate-y-0 assist:!translate-y-0 motion-reduce:!translate-y-0 pointer-event-none':
                    this.isCollapsed() && !this.isHeaderMenuOpen(),

                'scheme-dark !bg-transparent':
                    this.is_transparent || this.is_search_mode,

                'scheme-white dark:scheme-dark': !this.is_premiere && !this.is_transparent || this.is_menu_open,

                'dark:delay-300': !this.is_menu_open,

                'scheme-premiere': this.is_premiere && !this.is_menu_open
            }
        },

        ['x-on:wheel.window.passive']() {
            // noinspection JSUnresolvedReference
            this.handleScroll();
        },

        ['x-on:touchmove.window.passive.debounce.50ms']() {
            // noinspection JSUnresolvedReference
            this.handleScroll();
        },

        ['x-on:scroll.window.passive.throttle.100ms']() {
            // noinspection JSUnresolvedReference
            this.handleScroll();
        },

        ['x-on:scroll.window.passive.debounce.50ms']() {
            // noinspection JSUnresolvedReference
            this.handleScroll();
        },

    },

    /**
     * Директивы для блока с меню и логотипом
     */
    nav_left: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'hidden lg:flex': this.is_search_mode,
                'flex': !this.is_search_mode,
                'dark':
                    (
                        this.is_on_dark
                        ||
                        (
                            this.is_transparent
                            &&
                            this.is_transparent_on_dark
                        )
                    )
                    &&
                    !this.isHeaderMenuOpen()
            }
        },
    },

    /**
     * Директивы для контейнера навигационной панели
     */
    nav_container: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'border-b assist:border-b-2 border-stone-300 dark:border-bunker-800 assist:!border-assist-text':
                    !this.isCollapsed() && !this.isHeaderMenuOpen() && !this.is_search_mode,

                'border-b assist:border-b-2 border-stone-300 assist:!border-assist-text md:border-transparent':
                    this.isHeaderMenuOpen() && !this.is_search_mode,
            }
        },
    },

    /**
     * Директивы для меню первого уровня
     */
    primary_menu: {

        /**
         * Условие отображение фоновой плашки
         */
        ['x-show']() {
            // noinspection JSUnresolvedReference
            return !this.is_search_mode && (this.isHeaderMenuOpen() || !this.is_mobile)
        },

        /**
         * Динамическая установка стилей
         */
        ['x-bind:style']() {
            // noinspection JSUnresolvedReference
            return {
                '--active-menu-item-left': this.active_menu_item_left + 'px',
                '--active-menu-item-width': this.active_menu_item_width + 'px',
                '--active-menu-item-opacity': this.active_menu_item_opacity,
            }
        },

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'hidden': this.is_search_mode && !this.is_mobile,
                'opacity-0 md:opacity-100': !this.is_menu_open,
                'opacity-100 translate-x-0': this.is_menu_open
            }
        },

        ['x-on:resize.window.passive.debounce']() {
            // noinspection JSUnresolvedReference
            this.updateActiveMenuItemIndicator();
        }
    },

    /**
     * Поиск по сайту
     */
    search_form: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'hidden': !this.is_search_mode
            }
        },

        /**
         * Мгновенное (без debounce) обновление пункта-эха набираемого
         * запроса — как в адресной строке Chrome: первая подсказка
         * (= текст запроса) и уже закэшированные подсказки обновляются
         * на каждое нажатие клавиши, не дожидаясь debounced-запроса к серверу.
         */
        ['x-on:input']() {
            this.updateSearchSuggestionsImmediate();
        },

        ['x-on:input.debounce']() {
            // noinspection JSUnresolvedReference
            this.getSearchQuerySuggestions();
        },

        /**
         * Навигация вниз по списку подсказок (как в адресной строке Chrome)
         */
        ['x-on:keydown.down.prevent']() {
            this.moveSearchSelection(1);
        },

        /**
         * Навигация вверх по списку подсказок
         */
        ['x-on:keydown.up.prevent']() {
            this.moveSearchSelection(-1);
        },

        /**
         * Enter по выделенному пункту: для перехода (nav) — открываем ссылку,
         * для поискового пункта — отправляем форму с его текстом.
         */
        ['x-on:keydown.enter'](event) {
            this.handleSearchSuggestionEnter(event);
        },

        ['x-on:submit'](event) {
            // noinspection JSUnresolvedReference
            let search_term = this.$refs.search_input.value.trim();

            // noinspection JSUnresolvedReference
            if (!search_term.length) {
                event.preventDefault();
                // noinspection JSUnresolvedReference
                this.$refs.search_input.focus();
            }
        },

        ['x-on:keydown.esc']() {
            // noinspection JSUnresolvedReference
            this.$refs.search_input.blur();

            this.is_search_mode = false;
        },

        /**
         * Если плашку поиска открыли вводом символа (не кликом по кнопке)
         * и поле опустело после Backspace — закрываем плашку.
         */
        ['x-on:keyup.backspace']() {
            if (this.search_opened_by !== 'keypress') {
                return;
            }

            // noinspection JSUnresolvedReference
            if (this.$refs.search_input.value.length) {
                return;
            }

            // noinspection JSUnresolvedReference
            this.$refs.search_input.blur();

            this.is_search_mode = false;
        },

    },

    /**
     * Поле поиска
     */
    search_input: {

        ['x-on:click.prevent']() {
            // noinspection JSUnresolvedReference
            this.$refs.search_input.focus();
        }

    },

    /**
     * Кнопка поиска
     */
    search_btn: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            // noinspection JSUnresolvedReference
            return {
                'btn-cerise': this.is_search_mode
            }
        },

        ['x-on:click.prevent']() {
            // noinspection JSUnresolvedReference
            if (this.isHeaderMenuOpen()) {
                // noinspection JSUnresolvedReference
                this.closeHeaderMenu();
            }

            // noinspection JSUnresolvedReference
            if (!this.is_search_mode) {
                this.search_opened_by = 'button';
                this.is_search_mode = true;
                Alpine.nextTick().then(() => {
                    // noinspection JSUnresolvedReference
                    this.$refs.search_input.focus();
                })
                return;
            }

            // noinspection JSUnresolvedReference
            if (this.$refs.search_input.value.length) {
                // noinspection JSUnresolvedReference
                this.$refs.search_form.submit();
            } else {
                // noinspection JSUnresolvedReference
                this.$refs.search_input.focus();
            }
        }

    },

    /**
     * Директивы для меню второго уровня
     */
    secondary_menu: {

        /**
         * Условие отображение меню сайта
         */
        ['x-show']() {
            // noinspection JSUnresolvedReference
            return this.isHeaderMenuOpen() && this.has_active_item
        },

        /**
         * Динамическая установка стилей
         */
        ['x-bind:style']() {

            /*if (window.innerWidth <= 1280) {
                return {
                    'marginLeft': null
                }
            }

            return {
                'marginLeft': -this.scrollbar_width + 'px'
            }*/
        },
    },

    /**
     * Инициализация шапки и меню сайта
     */
    init() {

        // noinspection JSUnresolvedReference
        this.lang = this.$root.dataset.lang;

        // noinspection JSUnresolvedReference
        this.base_url = this.$root.dataset.baseUrl;

        // noinspection JSUnresolvedReference
        this.$watch('active_menu_item', (value) => {
            this.has_active_item = !!value
        });

        // noinspection JSUnresolvedReference
        this.is_on_dark = !!parseInt(this.$root.dataset.isOnDark);

        // noinspection JSUnresolvedReference
        this.is_premiere = !!parseInt(this.$root.dataset.isPremiere);

        // noinspection JSUnresolvedReference
        this.is_transparent_on_dark = !!parseInt(this.$root.dataset.transparentOnDark);

        // noinspection JSUnresolvedReference
        this.visit_menu_item = this.$root.dataset.visitMenuItem ?? '';

        // noinspection JSUnresolvedReference
        this.active_menu_item = this.$root.dataset.visitMenuItem ?? '';

        // noinspection JSUnresolvedReference
        const transparentTriggerSelector = this.$root.dataset.transparentTrigger;

        if (transparentTriggerSelector.length) {
            this.transparent_trigger = document.querySelector(transparentTriggerSelector);
        }

        // noinspection JSUnresolvedReference
        this.search_suggestions_default = JSON.parse(this.$root.dataset.searchSuggestionsDefault);

        this.filterStoredQuerySuggestions();

        this.handleScroll();

        Alpine.nextTick().then(() => {
            this.updateActiveMenuItemIndicator();
        });

        // noinspection JSUnresolvedReference
        this.$watch('is_menu_open', (is_menu_open) => {

            console.log('is_menu_open', is_menu_open);

            this.handleScroll();

            Alpine.nextTick().then(() => {
                this.updateActiveMenuItemIndicator();
            });

            if (this.is_menu_open) {
                document.body.classList.add('header-menu-open');
            } else {
                document.body.classList.remove('header-menu-open');
            }
        });

        // noinspection JSUnresolvedReference
        this.$watch('active_menu_item', () => {
            Alpine.nextTick().then(() => {
                this.updateActiveMenuItemIndicator();
            });
        });

        // noinspection JSUnresolvedReference
        this.$watch('is_collapsed', () => {
            this.updateActiveMenuItemIndicator();
        });

        // noinspection JSUnresolvedReference
        this.$watch('is_search_mode', () => {
            if (this.is_search_mode) {
                this.filterStoredQuerySuggestions();
            } else {
                // Сбрасываем навигацию и возвращаем в поле оригинальный запрос,
                // чтобы при повторном открытии не остался текст выделенного пункта
                this.search_selected_index = -1;

                // noinspection JSUnresolvedReference
                if (this.$refs.search_input) {
                    // noinspection JSUnresolvedReference
                    this.$refs.search_input.value = this.search_query;
                }
            }
        });

        setInterval(() => {
            this.updateActiveMenuItemIndicator();
        }, 1000);

        document.addEventListener('keydown', (event) => {

            if (this.is_search_mode) {
                return;
            }

            if (event.ctrlKey || event.metaKey || event.altKey || event.code === 'Space') {
                return;
            }

            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
                return;
            }

            if (event.key.length !== 1) {
                return;
            }

            this.search_opened_by = 'keypress';
            this.is_menu_open   = false;
            this.is_search_mode = true;

            Alpine.nextTick().then(() => {

                // noinspection JSUnresolvedReference
                this.$refs.search_input.focus();

                // noinspection JSUnresolvedReference
                this.$refs.search_input.value += event.key;
            })
        });
    },

    /**
     * Переключение видимости меню сайта
     */
    handleMenuButtonClick() {
        // Если меню открыто - закрываем его
        if (this.isHeaderMenuOpen()) {
            this.closeHeaderMenu();
            return;
        }

        // Иначе открываем меню
        this.openHeaderMenu();

        // Если мобильный экран — сначала показываем меню первого уровня
        if (this.is_mobile) {
            this.setActiveItem('', '');
            this.setSelectedItem('');
            return;
        }

        // Выбираем первый элемент меню:
        // - подсвеченный пункт меню первого уровня не выбран
        // - активное меню второго уровня не выбрано
        // - выбран пункт меню «Новая сцена» (без меню второго уровня)
        if (this.active_menu_item === '' || this.selected_menu_item === '' || this.active_menu_item === 'new-theater') {
            // noinspection JSUnresolvedReference
            let firstMenuItemSlug = this.$root.querySelector('.menu-item[data-menu-item]').dataset.menuItem ?? '';
            // noinspection JSUnresolvedReference
            let firstMenuItemName = this.$root.querySelector('.menu-item[data-menu-item]').dataset.menuName ?? '';

            this.setActiveItem(firstMenuItemSlug, firstMenuItemName);
            this.setSelectedItem(firstMenuItemSlug);
        }
    },

    /**
     * Мобильный экран?
     */
    isMobile() {
        return document.documentElement.clientWidth < this.menu_breakpoint_width;
    },

    /**
     * Открыто ли меню
     */
    isHeaderMenuOpen() {
        return this.is_menu_open;
    },

    /**
     * Свернута ли шапка (при прокрутке вниз)
     */
    isCollapsed() {
        return this.is_collapsed && !this.is_menu_open && !this.is_search_mode
    },

    /**
     * Открыть меню
     */
    openHeaderMenu() {
        this.is_search_mode = false;
        this.is_menu_open   = true;

        Alpine.nextTick().then(() => {
            this.scrollbar_width = parseInt(document.documentElement.style.paddingRight);
        });
    },

    /**
     * Закрытие меню сайта
     */
    closeHeaderMenu() {
        this.setActiveItem(this.visit_menu_item, '');

        this.is_menu_open    = false;
        this.scrollbar_width = 0;
    },

    /**
     * Обработка события прокрутки
     */
    handleScroll() {
        this.checkCollapsed();
        this.checkTransparentTrigger();
    },

    /**
     * Проверка условий скрытия меню сайта
     */
    checkCollapsed() {
        if (this.is_search_mode) {
            this.scroll_vector = 0;
        }

        this.last_scroll_top = this.scroll_top;
        this.scroll_top      = document.documentElement.scrollTop;

        let scrollDelta = this.scroll_top - this.last_scroll_top;

        this.scroll_direction = this.last_scroll_top < this.scroll_top
            ? 'down'
            : 'up';

        this.scroll_vector += scrollDelta;
        if (this.scroll_vector > 32) {
            this.scroll_vector = 32;
        }
        if (this.scroll_vector < -32) {
            this.scroll_vector = -32;
        }

        this.is_collapsed = this.scroll_top > 100 && this.scroll_vector > 16;

        if (this.isCollapsed()) {
            document.documentElement.classList.remove('fixed-header');
        } else {
            document.documentElement.classList.add('fixed-header');
        }
    },

    /**
     * Проверка условий прозрачности навигационной панели меню сайта
     */
    checkTransparentTrigger() {
        if (!this.transparent_trigger) {
            return;
        }

        this.transparent_trigger_start = this.transparent_trigger.offsetTop ?? 0;

        this.transparent_trigger_end = this.transparent_trigger.clientHeight ?? 0;
        this.transparent_trigger_end += this.transparent_trigger_start;

        this.is_transparent = !this.isHeaderMenuOpen()
            && this.scroll_top >= this.transparent_trigger_start
            && this.scroll_top <= this.transparent_trigger_end;
    },

    handleMenuItemHover(slug, title) {
        if (this.has_hover_cooldown) {
            return;
        }

        if (!this.isHeaderMenuOpen()) {
            return;
        }

        if (document.documentElement.clientWidth < this.menu_breakpoint_width) {
            return;
        }

        this.setActiveItem(slug, title);
        this.setSelectedItem(slug);
    },

    /**
     * Устанавливает активный пункт меню
     */
    setActiveItem(slug, title) {
        this.active_menu_item       = slug;
        this.active_menu_item_title = title;

        if (title !== '') {
            this.setSelectedItem(slug);
        }
    },

    /**
     * Устанавливает активное меню (содержимое)
     */
    setSelectedItem(slug) {
        this.selected_menu_item = slug;
    },

    updateActiveMenuItemIndicator() {

        // Ждем пока полоса прокрутки обновится при переключении меню
        setTimeout(() => {

            let activeMenuItemElement = document.querySelector('[x-bind="primary_menu"] li:first-child');

            if (this.active_menu_item) {
                activeMenuItemElement = document.querySelector('[x-bind="primary_menu"] li[data-menu-item="'
                    + this.active_menu_item + '"]');
            }

            if(!activeMenuItemElement){
                return;
            }

            this.active_menu_item_left  = activeMenuItemElement.offsetLeft;
            this.active_menu_item_width = activeMenuItemElement.clientWidth;

            this.active_menu_item_opacity = this.active_menu_item ? 1 : 0;

        }, 100);
    },

    setHoverMenuItemTimeout(slug, title) {
        this.clearHoverMenuItemTimeout();

        Alpine.nextTick().then(() => {
            this.hover_timeout = setTimeout(() => {

                this.handleMenuItemHover(slug, title);

            }, this.hover_timeout_duration)
        });
    },

    clearHoverMenuItemTimeout() {
        clearTimeout(this.hover_timeout);
    },

    /**
     * Подбор подсказок для поля поиска
     */
    getSearchSuggestions() {
        const query = this.search_query.trim();
        const hasQuery = query.length >= this.search_query_min_length;

        let rest = [];

        // Навигационные подсказки-переходы — сверху списка, лимит nav_max

        for (let i = 0; i < this.search_suggestions_nav.length && i < this.search_suggestions_nav_max; i++) {
            rest.push({
                text: this.search_suggestions_nav[i].text,
                url: this.search_suggestions_nav[i].url,
                type: 'nav'
            })
        }

        // Результаты по запросу

        for (let i = 0; i < this.search_suggestions_query.length; i++) {
            rest.push({
                text: this.search_suggestions_query[i],
                type: 'query'
            })
        }

        if (!rest.length) {
            // Результаты из истории

            for (let i = 0; i < Alpine.store('global').search_suggestions_history.length; i++) {
                rest.push({
                    text: Alpine.store('global').search_suggestions_history[i],
                    type: 'history'
                })
            }

            // Подсказки по умолчанию

            if (rest.length < this.search_suggestions_max) {
                for (let i = 0; i < this.search_suggestions_default.length; i++) {
                    rest.push({
                        text: this.search_suggestions_default[i],
                        type: 'default'
                    })
                }
            }
        }

        // Дедуплицируем по нормализованному тексту во всех ветках: для
        // nav/query это вытесняет одноимённые строковые подсказки переходами
        // (nav добавлены раньше), а для истории/умолчаний убирает дубли,
        // которые слабее ловит точечный === в addSearchHistory (регистр, ё/е,
        // ранее накопленные в localStorage записи).
        rest = this.dedupeSuggestionsByText(rest);

        let suggestions = [];

        if (hasQuery) {
            // Оригинальный текст запроса — всегда первым пунктом и выделен по
            // умолчанию (как «Афиша - поиск» в адресной строке Chrome).
            suggestions.push({
                text: query,
                type: 'query',
                is_original: true
            });

            // Из остальных убираем дубли оригинала, НО оставляем переходы:
            // «Афиша - nav» (ссылка в раздел) и «Афиша - поиск» — это разные пункты.
            const originalKey = this.normalizeSuggestionText(query);
            rest = rest.filter(item =>
                item.type === 'nav' || this.normalizeSuggestionText(item.text) !== originalKey
            );
        }

        this.search_suggestions = suggestions.concat(rest).slice(0, this.search_suggestions_max);

        // Сброс выделения: на оригинал (первый пункт) при запросе, иначе без выделения
        this.search_selected_index = hasQuery && this.search_suggestions.length ? 0 : -1;
    },

    /**
     * Дедуп подсказок по нормализованному тексту (регистр + ё/е). Сохраняется
     * первое вхождение, поэтому навигационные переходы, добавленные раньше,
     * вытесняют одноимённые строковые подсказки (например, страницу «Контакты»).
     */
    dedupeSuggestionsByText(suggestions) {
        const seen = new Set();
        const result = [];

        for (const suggestion of suggestions) {
            const key = this.normalizeSuggestionText(suggestion.text);

            if (seen.has(key)) {
                continue;
            }

            seen.add(key);
            result.push(suggestion);
        }

        return result;
    },

    /**
     * Нормализация текста подсказки для сравнения (регистр + ё/е + пробелы)
     */
    normalizeSuggestionText(text) {
        return text.toLowerCase().replace(/ё/g, 'е').trim();
    },

    /**
     * Перемещение выделения по списку подсказок (с зацикливанием).
     * Текст выделенного пункта подставляется в поле, НЕ затрагивая
     * search_query — источник подсказок остаётся прежним.
     */
    moveSearchSelection(delta) {
        const count = this.search_suggestions.length;

        if (!count) {
            return;
        }

        let index = this.search_selected_index;

        // Из состояния «нет выделения» вниз идём к первому, вверх — к последнему
        if (index < 0) {
            index = delta > 0 ? 0 : count - 1;
        } else {
            index += delta;

            if (index < 0) {
                index = count - 1;
            } else if (index >= count) {
                index = 0;
            }
        }

        this.search_selected_index = index;
        this.applySearchSelectionToInput();
    },

    /**
     * Подстановка текста выделенного пункта в поле ввода.
     * Меняем DOM-значение напрямую, не трогая search_query, чтобы не
     * перезапускать подбор подсказок (они смотрят на оригинальный запрос).
     */
    applySearchSelectionToInput() {
        const item = this.search_suggestions[this.search_selected_index];

        if (!item) {
            return;
        }

        // noinspection JSUnresolvedReference
        this.$refs.search_input.value = item.is_original ? this.search_query : item.text;
    },

    /**
     * Обработка Enter по выделенному пункту подсказок.
     * Переход (nav) — открываем ссылку; поисковый пункт — отправляем форму
     * (значение поля уже равно тексту пункта).
     */
    handleSearchSuggestionEnter(event) {
        const item = this.search_suggestions[this.search_selected_index];

        if (!item) {
            return;
        }

        if (item.type === 'nav') {
            event.preventDefault();
            window.location.href = item.url;
            return;
        }

        // Поисковый пункт: гарантируем актуальное значение поля и даём форме
        // отправиться штатно (?s=<текст>).
        // noinspection JSUnresolvedReference
        this.$refs.search_input.value = item.is_original ? this.search_query : item.text;
    },

    /**
     * Синхронная часть подбора подсказок (без обращения к серверу):
     * эхо текущего запроса первым пунктом + уже закэшированные по этому
     * запросу подсказки. Вызывается на каждое нажатие клавиши.
     */
    updateSearchSuggestionsImmediate() {
        const query = this.search_query.trim();

        if (query.length < this.search_query_min_length) {
            this.search_suggested_event_html = '';
        }

        this.filterStoredQuerySuggestions();
    },

    getSearchQuerySuggestions() {
        let query = this.search_query.trim();

        if (query.length < this.search_query_min_length) {
            this.search_suggested_event_html = '';
            // Запрос стёрт/слишком короткий — возвращаем начальные подсказки
            // (default/история). Иначе остаются устаревшие подсказки по запросу.
            this.filterStoredQuerySuggestions();
            return;
        }

        const found = this.filterStoredQuerySuggestions();
        if (found) {
            return;
        }

        // Параметры запроса
        let searchParamsData = {};

        searchParamsData.action = 'search_query_suggestions';

        searchParamsData.query = query;

        searchParamsData.lang = this.lang;

        // noinspection JSCheckFunctionSignatures
        axios.get(window["yep_ajax"].url, {
            params: searchParamsData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
        }).then(response => {
            if (response.data.suggestions.length) {
                this.search_suggestions_stored[query] = response.data.suggestions;
                this.search_suggestions_correction[query] = response.data.query_correction ?? '';
                this.search_suggestions_nav_stored[query] = response.data.nav_suggestions ?? [];

                // noinspection JSUnresolvedReference
                this.search_suggested_event_html = response.data.suggested_event_html;

                this.filterStoredQuerySuggestions();
            }
        }).catch(error => {
            this.filterStoredQuerySuggestions();

            console.error(error);
        }).finally(() => {

        });
    },

    filterStoredQuerySuggestions() {
        let query = this.search_query.trim();

        this.search_suggestions_query = [];

        // Навигационные подсказки уже отфильтрованы по совпадению на сервере —
        // берём как есть (пустой массив для короткого/пустого запроса).
        this.search_suggestions_nav = this.search_suggestions_nav_stored[query] ?? [];

        let stored = this.search_suggestions_stored[query] ?? [];

        // Исправление-синоним пропускаем, даже если оно не содержит запрос
        // («жизель» не содержит «жазель»). Остальное режем по подстроке, чтобы
        // не показывать нерелевантные короткие фрагменты многословных подсказок.
        let correction = (this.search_suggestions_correction[query] ?? '').toLowerCase();

        let storedSuggestions = stored.filter(suggestion => {
            const s = suggestion.toLowerCase();
            return s.includes(query.toLowerCase()) || (correction !== '' && s === correction);
        });

        if (storedSuggestions.length) {
            this.search_suggestions_query = storedSuggestions;
        }

        Alpine.nextTick().then(() => {
            this.getSearchSuggestions();
        });

        return this.search_suggestions_query.length;
    }

})
